import { useMutation, useQuery, useQueryClient } from "react-query";
import qs from "qs-lite";

import api from "../../utils/api";
import { invalidate } from "../../helpers/clientHelper";
import { useHubSnackBar } from "../useSnackBar";

const ROLES = "/roles";
const CACHE_TIME = 30_600_000;

const getRolesList = ({ queryKey }) => {
  const queryString = qs.stringify(queryKey[1]);
  const query = queryString ? `?${queryString}` : "";
  return api.get(`${ROLES}${query}`);
};
export const useGetRolesList = ({ locationId = null, enabled = true } = {}) => {
  return useQuery([ROLES, { locationId }, "/list"], getRolesList, {
    enabled,
    staleTime: CACHE_TIME,
    cacheTime: CACHE_TIME,
  });
};

const getRolesTable = ({ queryKey }) => {
  const queryString = qs.stringify(queryKey[1]);
  return api.get(`${ROLES}/table?${queryString}`);
};
export const useGetRolesTable = ({ locationId = 1 }) => {
  const query = new URLSearchParams(window.location.search);

  const queryLocation = query.get("location");
  const location = [1, 2].includes(queryLocation) ? queryLocation : locationId;
  const queryParams = {
    locationId: location,
  };

  return useQuery([ROLES, queryParams, "/table"], getRolesTable, {
    enabled: !!locationId,
  });
};

const putRolePermissionValue = ({ roleId, permissionId, value }) =>
  api.put(`${ROLES}`, { roleId, permissionId, value });
export const usePutRolePermissionValue = (onError = () => {}) => {
  return useMutation(putRolePermissionValue, {
    onError,
  });
};

const postCreateRole = ({ roleId, name }) =>
  api.post(`${ROLES}`, { roleId, name });
export const usePostCreateRole = () => {
  const { addSnackbarSuccess } = useHubSnackBar();
  const queryClient = useQueryClient();

  return useMutation(postCreateRole, {
    onSuccess: () => {
      invalidate(queryClient, ROLES);
      addSnackbarSuccess({ message: "Successfully Created Role" });
    },
  });
};
